
import Vue from 'vue';
import '/assets/checkbox.css';

export default Vue.extend({
  name: 'checkbox',
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: false,
    }
  },
  methods: {
    updateValue(val: boolean) {
      this.$emit('input', val);
    }
  }
})
